module.exports = __webpack_public_path__ + "static/media/database.15a7a65e.svg";